import TogleSwitch from "./ToggleSwitch";
export default TogleSwitch;
